<template>
    <div id="notifications-template">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Live Class', to: { path: '/live-class' } },
                { text: 'Laporan Live Class' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <div>
            <v-row>
                <v-col cols="12" md="10">
                    <h3 class="header-text font-weight-bold">
                        Laporan Live Class
                    </h3>
                </v-col>

                <v-cols cols="12" md="2" class="align-right">
                    <div class="text-right mt-5">
                        <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-width="120"
                            offset-x
                        >
                            <template
                                v-slot:activator="{ on, attrs }"
                                class="text-right"
                            >
                                <span style="font-size: 16px">
                                    Filter &nbsp;&nbsp;</span
                                >
                                <v-btn
                                    depressed
                                    color="white"
                                    v-bind="attrs"
                                    v-on="on"
                                    width="120"
                                >
                                    <span class="blew--text">
                                        <span v-if="filter_type === 'ALL'"
                                            >Semua</span
                                        >
                                        <span v-if="filter_type === 'CUSTOM'"
                                            >Custom</span
                                        >
                                        <v-icon color="blew" small class="ml-6">
                                            mdi-chevron-down
                                        </v-icon>
                                    </span>
                                </v-btn>
                            </template>

                            <v-card class="pt-7" width="350">
                                <v-card-title>
                                    <v-row>
                                        <v-col cols="12" md="12">
                                            <div style="font-size: 14px">
                                                Rentang Tanggal
                                            </div>
                                            <div>
                                                <v-select
                                                    outlined
                                                    placeholder="Pilih Rentang Tanggal"
                                                    v-model="filter_type"
                                                    class="pa-0"
                                                    :items="[
                                                        {
                                                            text: 'Semua',
                                                            value: 'ALL',
                                                        },
                                                        {
                                                            text: 'Custom',
                                                            value: 'CUSTOM',
                                                        },
                                                    ]"
                                                ></v-select>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="filter_type === 'CUSTOM'">
                                        <v-col cols="12" md="12">
                                            <v-row>
                                                <v-col cols="12" md="6">
                                                    <div
                                                        style="font-size: 14px"
                                                    >
                                                        Dari Tanggal
                                                    </div>
                                                    <div>
                                                        <v-dialog
                                                            ref="dialog"
                                                            v-model="modal_date"
                                                            :return-value.sync="
                                                                date
                                                            "
                                                            persistent
                                                            width="290px"
                                                        >
                                                            <template
                                                                v-slot:activator="{
                                                                    on,
                                                                    attrs,
                                                                }"
                                                            >
                                                                <v-text-field
                                                                    v-model="
                                                                        date
                                                                    "
                                                                    outlined
                                                                    dense
                                                                    readonly
                                                                    v-bind="
                                                                        attrs
                                                                    "
                                                                    v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                v-model="date"
                                                                scrollable
                                                            >
                                                                <v-spacer></v-spacer>
                                                                <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="
                                                                        modal_date = false
                                                                    "
                                                                >
                                                                    Cancel
                                                                </v-btn>
                                                                <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="
                                                                        $refs.dialog.save(
                                                                            date,
                                                                        )
                                                                    "
                                                                >
                                                                    OK
                                                                </v-btn>
                                                            </v-date-picker>
                                                        </v-dialog>
                                                    </div>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <div
                                                        style="font-size: 14px"
                                                    >
                                                        Sampai Tanggal
                                                    </div>
                                                    <div>
                                                        <v-dialog
                                                            ref="dialog2"
                                                            v-model="
                                                                modal_date2
                                                            "
                                                            :return-value.sync="
                                                                date2
                                                            "
                                                            persistent
                                                            width="290px"
                                                        >
                                                            <template
                                                                v-slot:activator="{
                                                                    on,
                                                                    attrs,
                                                                }"
                                                            >
                                                                <v-text-field
                                                                    v-model="
                                                                        date2
                                                                    "
                                                                    outlined
                                                                    dense
                                                                    readonly
                                                                    v-bind="
                                                                        attrs
                                                                    "
                                                                    v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                v-model="date2"
                                                                scrollable
                                                            >
                                                                <v-spacer></v-spacer>
                                                                <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="
                                                                        modal_date2 = false
                                                                    "
                                                                >
                                                                    Cancel
                                                                </v-btn>
                                                                <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="
                                                                        $refs.dialog2.save(
                                                                            date2,
                                                                        )
                                                                    "
                                                                >
                                                                    OK
                                                                </v-btn>
                                                            </v-date-picker>
                                                        </v-dialog>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-title>
                                <v-card-actions class="pb-5 pr-3">
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        rounded
                                        depressed
                                        @click="menu = false"
                                    >
                                        Batal
                                    </v-btn>
                                    <v-btn
                                        rounded
                                        depressed
                                        color="primary"
                                        @click="doFilter()"
                                    >
                                        Terapkan
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-menu>
                    </div>
                </v-cols>
            </v-row>
        </div>

        <div class="mb-10 mt-2">
            <v-row>
                <v-col cols="3">
                    <v-card flat class="mt-5">
                        <v-card-text class="pa-5">
                            <div class="grey--text">Total Semua Problem</div>
                            <div
                                class="font-weight-700 black--text mt-2"
                                style="font-size: 24px"
                            >
                                {{ total_problem }}
                                <span style="font-size: 14px">Laporan</span>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="3" v-for="(data, index) of problem" :key="index">
                    <v-card flat class="mt-5">
                        <v-card-text class="pa-5">
                            <div class="grey--text">
                                {{ data.problem_name }}
                            </div>
                            <div
                                class="font-weight-700 black--text mt-2"
                                style="font-size: 24px"
                            >
                                {{ data.count }}
                                <span
                                    class="font-weight-400"
                                    style="font-size: 14px"
                                >
                                    Laporan
                                </span>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>

        <v-card>
            <v-card-title> Laporan Live Class </v-card-title>
            <v-divider />

            <app-datatable
                :items="data"
                :headers="headers"
                :has-action="false"
                :has-export="true"
                :has-duplicate="true"
                :has-custom-pagination="true"
                :has-custom-search="true"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="total"
                :custom-pagination-sort-mode="pagination.sortMode"
                v-on:selected="selectedRow = $event"
                v-on:exportClicked="exportTryout()"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = $event.value;
                    tableKey = $event.key.value;
                    doSearch();
                "
            ></app-datatable>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import axios from "axios";

export default {
    name: "notifications-template",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            isLoading: false,
            selectedRow: "",
            total: 0,
            start_date: "",
            end_date: "",
            search: "",
            tableKey: "",
            sortBy: "",
            filters: "",
            pagination: {
                perPage: 20,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            data: [],
            problem: [],
            total_problem: 0,
            headers: [
                {
                    text: "Nama Live Class",
                    value: "class_name",
                    width: "200px",
                },
                { text: "Nama Teacher", value: "teacher_name" },
                { text: "Tanggal Live Class", value: "class_date" },
                { text: "Alasan Laporan", value: "problem_name" },
                {
                    text: "Detail Laporan",
                    value: "detail_problem",
                    width: "300px",
                },
            ],
            filter_type: "ALL",
            menu: false,
            modal_date: false,
            modal_date2: false,
            date: "",
            date2: "",
        };
    },

    watch: {
        pagination() {
            this.fetchData();
        },
        filter_type() {
            if (this.filter_type === "ALL") {
                this.date = "";
                this.date2 = "";
            } else {
                const date = new Date(
                    Date.now() - new Date().getTimezoneOffset() * 60000,
                )
                    .toISOString()
                    .substr(0, 10);

                const date2 = new Date(
                    Date.now() - new Date().getTimezoneOffset() * 60000,
                )
                    .toISOString()
                    .substr(0, 10);

                this.date = date;
                this.date2 = date2;
            }
        },
    },

    mounted: function () {
        this.fetchData();
        this.fetchListProblem();
    },

    methods: {
        fetchData() {
            const context = this;
            const param = `?start_date=${context.start_date}&end_date=${context.end_date}&sort_by=${context.sortBy}&sort=${context.pagination.sortMode}&size=${context.pagination.perPage}&page=${context.pagination.currentPage}&search=${context.search}&tabel_key=${context.tableKey}`;

            const url = `${process.env.API_BASE_URL}liveclass/admin/list-reports${param}`;

            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            context.user_groups = [];
            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.data = response.data.reports;
                    context.total = Math.ceil(
                        response.data.total_report / context.pagination.perPage,
                    );
                }
            });
        },
        fetchListProblem() {
            const context = this;
            const param = `?start_date=${context.start_date}&end_date=${context.end_date}`;
            const url = `${process.env.API_BASE_URL}liveclass/admin/list-reports-problem${param}`;

            const authToken = JSON.parse(localStorage.getItem("token")).value;

            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            context.user_groups = [];
            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.problem = response.data.total_report_problems;
                    context.total_problem = response.data.total_report;
                }
            });
        },
        doFilter() {
            this.menu = false;
            this.start_date = this.formatDate(this.date);
            this.end_date = this.formatDate(this.date2);

            this.fetchData();
            this.fetchListProblem();
        },
        doSearch() {
            if (this.tableKey === "class_date") {
                this.search = this.formatDate2(this.search);
            }
            this.fetchData();
        },
        formatDate(date) {
            if (!date) return "";

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        formatDate2(date) {
            if (!date) return "";

            return date.replaceAll("/", "-");
        },
    },
};
</script>



// WEBPACK FOOTER //
// LiveClassReport.vue?56f63a29